import { Button, Card, Dropdown, Nav } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import Scrollbar from 'components/base/Scrollbar';
import classNames from 'classnames';
import { useAccessToken } from 'providers/AccessTokenProvider';
import EmployeeAvatar from 'components/base/EmployeeGravatar';
import { toast } from 'react-hot-toast';
import { Employee } from 'data/users';

const ProfileDropdownMenu = ({
  className,
  profileImage,
  authUser
}: {
  className?: string;
  profileImage?: string;
  authUser?: Employee;
}) => {
  const { logout, authUser: sessionUser } = useAccessToken();
  const currentUser = authUser || sessionUser;
  const navItems = [
    {
      label: 'Profile',
      icon: 'user',
      href: '/profile'
    },
    {
      label: 'Language',
      icon: 'globe'
    }
  ];

  const handleLogout = async () => {
    try {
      await logout();
      toast.success('Logout successful');
      window.location.href = '/';
    } catch (error) {
      toast.error('Logout failed');
    }
  };

  return (
    <Dropdown.Menu
      align="end"
      className={classNames(
        className,
        'navbar-top-dropdown-menu navbar-dropdown-caret py-0 dropdown-profile shadow border border-300'
      )}
    >
      <Card className="position-relative border-0">
        <Card.Body className="p-0">
          <div className="d-flex flex-column align-items-center justify-content-center gap-2 pt-4 pb-3">
            <EmployeeAvatar
              src={profileImage || currentUser?.email}
              size="xl"
            />
            <h6 className="text-black">
              {currentUser?.firstName} {currentUser?.lastName}
            </h6>
          </div>

          <div style={{ height: '10rem' }}>
            <Scrollbar>
              <Nav className="nav flex-column mb-2 pb-1">
                {navItems.map(item => (
                  <Nav.Item key={item.label}>
                    <Nav.Link href={item.href} className="px-3">
                      <FeatherIcon
                        icon={item.icon}
                        size={16}
                        className="me-2 text-900"
                      />
                      <span className="text-1000">{item.label}</span>
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Scrollbar>
          </div>
        </Card.Body>
        <Card.Footer className="p-0 border-top">
          <Nav className="nav flex-column my-3">
            <Nav.Item>
              <Nav.Link href="/home/apps/employee" className="px-3">
                <FeatherIcon
                  icon="user-plus"
                  size={16}
                  className="me-2 text-900"
                />
                <span>Add another account</span>
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <hr />
          <div className="px-3 mb-3">
            <Button
              className="btn btn-phoenix-secondary d-flex flex-center w-100"
              onClick={handleLogout}
            >
              <FeatherIcon icon="log-out" className="me-2" size={16} />
              Sign out
            </Button>
          </div>
        </Card.Footer>
      </Card>
    </Dropdown.Menu>
  );
};

export default ProfileDropdownMenu;
